@if (imageUrl) {
  <div class="overlay">
    <div class="popup-content">
      <button class="close-btn" (click)="close()">
        <i class="fas fa-times" style="color: red"></i>
      </button>
      <img
        [src]="imageUrl"
        alt="Image Preview"
        class="image-preview"
        (error)="imageLoadError.set(true)"
      />
      @if (imageLoadError()) {
        <div class="error">
          Failed to load image.
        </div>
      }
    </div>
  </div>
}